import { render, staticRenderFns } from "./loadingLottieAll.vue?vue&type=template&id=21fd02aa&scoped=true"
import script from "./loadingLottieAll.vue?vue&type=script&lang=ts"
export * from "./loadingLottieAll.vue?vue&type=script&lang=ts"
import style0 from "./loadingLottieAll.vue?vue&type=style&index=0&id=21fd02aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd02aa",
  null
  
)

export default component.exports